import { render, staticRenderFns } from "./CameraCaptureBox.vue?vue&type=template&id=4f9a8319&scoped=true"
import script from "./CameraCaptureBox.vue?vue&type=script&lang=js"
export * from "./CameraCaptureBox.vue?vue&type=script&lang=js"
import style0 from "./CameraCaptureBox.vue?vue&type=style&index=0&id=4f9a8319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a8319",
  null
  
)

export default component.exports